var React = require('react');

function SectionBackgroundAccentInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0 0h2000c-1.932 5-81 5-81 5-109.215 2-261.395 27-572 27-258.91 0-313.516-26-572.425-26C515.67 6 515.67 32 256.766 32 256.766 32 113 32 0 0","fill":"currentColor"}));
}

SectionBackgroundAccentInline.defaultProps = {"width":"2000","height":"32"};

module.exports = SectionBackgroundAccentInline;

SectionBackgroundAccentInline.default = SectionBackgroundAccentInline;
